export const color: {[key: string]: string} = {};

declare module "styled-components" {
  export interface DefaultTheme extends Tema {}
}

export interface Tema {
  nome: string;

  texto: TextTheme;
  image: ImageTheme;
  background: BackgroundTheme;

  loading: string;

  tamanho: typeof TamanhoTheme;
}

interface TextTheme {
  cor_primaria: string;

  enfase_alta: string;
  enfase_media: string;
  enfase_baixa: string;
  desabilitado: string;

  erro: string;

  link: string;
}

interface ImageTheme {
  fillColor: string;
}

interface BackgroundTheme {
  cor_primaria: string,

  nivel_0: string;
  nivel_1: string;

  borda: string;

  loading: string;
}

export const TamanhoTheme = {
  celular: '48rem'
  // tablet
  // desktop
}

export const Spacing = {
  unit: 8
}